import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  CategoryInterface,
  selectCategoryById,
  setEditId,
  setEditError
} from "../../../store/mine_craft/categoriesSlice";
import { updateCategory, fetchCategory, fetchCategories } from "../../../actions/mine_craft/categoriesActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch  = useAppDispatch();
  const id: any   = useAppSelector(state => state.mineCraft.categories.editId);
  const category  = useAppSelector((state) => selectCategoryById(state, id));
  const error     = useAppSelector(state => state.mineCraft.categories.editError);

  useEffect(() => {
    if (id) {
      dispatch(fetchCategory(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: CategoryInterface) {
    const formData = objToFormData(data);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(updateCategory({ id, data }));

    if (updateCategory.fulfilled.match(resultAction)) {
      dispatch(fetchCategories({ target_id: category?.target_id }));
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-category'>
        <h6 className="v-content-label">Edit Category</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={category} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
